export default "__VITE_ASSET__DzbYW3yT__"